module.exports = __webpack_public_path__ + "img/mobile_type_one.1c8a5b30.png";